import _ from 'lodash'

class PasswordResetController {
  constructor(passwordResetService, $location, $log, auth) {
    this.$log = $log
    this.passwordResetService = passwordResetService
    this.$location = $location
    this.auth = auth
    this.resetSessionExpired =  'Your reset link has expired. Please click the following link if you still need to reset your password.'
  }

  request() {
    this.requestButtonDisabled = true
    this._clearResetMessages()
    this.passwordResetService.requestResetPasswordEmail(
        this.email,
        this._onEmailGenerated.bind(this),
        this._onEmailNotGenerated.bind(this))
  }

  _onEmailGenerated() {
    this.requestSuccess = 'Please check your inbox for an email with the next steps.'
  }
  _onEmailNotGenerated() {
    this.requestButtonDisabled = false
    this.requestFailure = 'Whoops! We could not generate a reset email at this time. Please try again later'
  }

  validate() {
    if (this.passwordResetService.validReset) {
      this._potentialLogout()
    }
    return this.passwordResetService.validReset
  }

  _potentialLogout() {
    if (this.auth.loggedIn) {
      this.auth.logout()
    }
  }

  change() {
    this.changeButtonDisabled = true
    this.passwordResetService.sendNewPassword(
        this.password,
        this._onPasswordChanged.bind(this),
        this._onPasswordNotChanged.bind(this))
  }

  _onPasswordChanged() {
    this.resetSuccessMessage = 'Reset successful! You may now sign in at the top of the page.'
  }

  _onPasswordNotChanged() {
    this.changeButtonDisabled = false
    this.resetFailedMessage = "Whoops! We could not change your password at this time. Please try again later."
  }

  _clearResetMessages() {
    this.resetSuccessMessage = null
    this.resetFailedMessage = null
  }
}

PasswordResetController.$inject = [
  'PasswordResetService',
  '$location',
  '$log',
  'AuthService'
]

export default PasswordResetController
